export { default as LinkedEntitlementsTable } from './linked-entitlements-table';
